import React from "react";
import Slider from "react-slick";
import "../../assets/css/slider.css";
import next from "../../assets/images/icon_next.png";
import prev from "../../assets/images/icon_prev.png";
import { HTMLParserHelper } from "../../helper/HTMLParserHelper";

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="slick-arrow" onClick={onClick}>
      <img src={prev} alt="prev" />
    </div>
  );
}

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="slick-arrow"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <img src={next} alt="next" />
    </div>
  );
}

export default class ReactSlickDemo extends React.Component {
  render() {
    var settings = {
      dots: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div className="slider-container">
          <div className="container slider_padding">
            {" "}
            <div className="row">
              {this.props.data.slider && (
                <div
                  style={{
                    background: "rgba(0,0,0,0)",
                    border: "solid 0px rgba(0,0,0,0)",
                    borderRadius: "0px",
                    padding: "0px 0px 0px 0px",
                  }}
                >
                  <div
                    id="home_slider"
                    className="owl-carousel owl-pagination-true owl-theme"
                    style={{ opacity: 1, display: "block" }}
                  ></div>
                  <Slider {...settings}>
                    {Object.entries(this.props.data.slider).map(
                      ([key, book]) => {
                        return (
                          <div key={key}>{HTMLParserHelper(book.content)}</div>
                        );
                      }
                    )}
                  </Slider>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
